import { backendUrl } from 'helpers/environment';

export const graphqlUrl = `${backendUrl}/graphql`;
export const graphqlWSUrl = graphqlUrl.replace('http', 'ws');
